<div class="order-confirmation-container">
  <div class="content" *ngIf="project === 'FS'; else lr">
    <div class="fs" *ngIf="order$ | async as order">
      <kion-device-short-info
        [device]="device$ | async"
      ></kion-device-short-info>
      <div class="groupheader">
        <div class="heading">{{ 'basket.confirmation.details.headline' | translate }}</div>
      </div>
      <div class="orderDetailGrid">
        <div class="orderValuePair">
          <div class="key">{{ 'basket.confirmation.details.summary' | translate }}</div>
          <div class="value">{{ order.totalPriceWithTax?.formattedValue }}</div>
        </div>
        <div class="orderValuePair">
          <div class="key">{{ 'basket.confirmation.details.poNumber' | translate }}</div>
          <div class="value">{{ order.purchaseOrderNumber }}</div>
        </div>
        <div class="orderValuePair">
          <div class="key">{{ 'basket.confirmation.details.orderNumber' | translate }}</div>
          <div class="value">{{ order.id }}</div>
        </div>
        <div class="orderValuePair">
          <div class="key">{{ 'basket.confirmation.details.notes' | translate }}</div>
          <div class="value">{{ order.userComment?.text }}</div>
        </div>
      </div>
      <div class="actionDetailGrid">
        <div class="spacer"></div>
        <div class="actions">
          <kion-button
            [title]="'basket.confirmation.actions.backToDevice' | translate"
            mode="default"
            link="/device-list/{{order?.device?.manufacturer?.toLowerCase()}}/{{order?.device?.serialNumber}}"
            [isLink]="true">
          </kion-button>
          <kion-button
            [title]="'basket.confirmation.actions.backToList' | translate"
            link="/device-list"
            [isLink]="true"
            mode="primary">
          </kion-button>
        </div>
      </div>
    </div>
  </div>
  <ng-template #lr>
    <div class="background">
      <img src="./assets/background/order_confirmation_background.png" alt="order_confirmation" title="order_confirmation" />
      <svg viewBox="0 0 200 20" class="basketInformationBackgroundTilt">
        <path d="M 0,12 200,0 v 20 H 0 Z" class="basketInformationBackgroundTiltPath"></path>
      </svg>
    </div>
    <div class="content" *ngIf="order$ | async as order; else noOrder">
      <div class="lr">
        <div class="description-text">
          <h1>{{ 'orderConfirmation.headline' | translate }}</h1>
          <table>
            <tr *ngIf="order.code as code">
              <td>{{ 'orderConfirmation.orderNumber.label' | translate }}</td>
              <td>{{ code }}</td>
            </tr>
            <!--tr>
              <td>{{ 'orderConfirmation.deliveryTime.label' | translate }}</td>
              <td>0</td>
            </tr-->
            <tr *ngIf="order.deliveryMode as deliveryMethod">
              <td>{{ 'orderConfirmation.deliveryMethod.label' | translate }}</td>
              <td>{{ deliveryMethod.name }}</td>
            </tr>
          </table>
        </div>
      </div>
    </div>
    <ng-template #noOrder></ng-template>
  </ng-template>
</div>
